export var cibStitcher = ["32 32", "<path d='M23.974 9.25h-0.479v13.5h0.479zM22.979 10.75h-0.479v10.5h0.479zM21.49 10.75h-21.49v10.5h21.49zM32 10.75h-6.010v10.5h6.010zM24.99 10.75h-0.479v10.5h0.479z'/>"];
